import { render, staticRenderFns } from "./Comandas.vue?vue&type=template&id=597ff089&scoped=true"
import script from "./Comandas.vue?vue&type=script&lang=js"
export * from "./Comandas.vue?vue&type=script&lang=js"
import style0 from "./Comandas.vue?vue&type=style&index=0&id=597ff089&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597ff089",
  null
  
)

export default component.exports